module.exports = __webpack_public_path__ + "./img/cli.49c47f06d2d257b62f2f9899ab8f77f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/img/mockups/cli.jpg
// module id = ./public/img/mockups/cli.jpg
// module chunks = 0